module.exports = __webpack_public_path__ + "static/img/finger-key1.6cf2b42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/remotekey/finger/finger-key1.jpg
// module id = EIJs
// module chunks = 0